"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginatedDownload = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function hasMoreData(response) {
    return response.skip + response.take < response.total;
}
async function paginatedDownload(fetcher, query, maxResults = Number.MAX_SAFE_INTEGER) {
    const skip = getNumberOrDefault(query?.skip, 0);
    const queryTake = getNumberOrDefault(query?.take, data_lib_1.MAX_TAKE);
    // Check take is greater than zero, if not we use the default take
    const take = queryTake > 0 ? queryTake : data_lib_1.MAX_TAKE;
    let currentSkip = skip;
    let lastResponse = null;
    do {
        const response = await fetcher({ ...query, skip: currentSkip, take });
        const hasMore = hasMoreData(response);
        // We modified the last results as it should have any extra fields on it
        response.skip = skip;
        response.results = (lastResponse?.results || []).concat(response.results);
        response.take = response.results.length;
        lastResponse = response;
        if (!hasMore) {
            return lastResponse;
        }
        currentSkip = skip + response.take;
    } while (currentSkip < maxResults);
    return lastResponse;
}
exports.paginatedDownload = paginatedDownload;
function getNumberOrDefault(value, defaultValue) {
    return typeof value === "number" ? value : defaultValue;
}
